export const RouteConstants = {
  home: "/",
  viewOrder: "/view-order/:id",
  viewSubscription: "/view-subscription/:id",
  login: "/login",
  signup: "/signup",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  resetPasswordOtp: "/reset-password-otp",
  resendLink: "/resend-link",
  register: "/register",
  confirmLink: "/confirm-link",
  forgetPassword: "/forgot-password",
  checkout: "/checkout",
  comingSoon: "/coming-soon",
  subscriptionConfirmation: "/subscription-confirmation",
  resetPasswordSecurityQuestion: "/reset-password-security-question",
  freetrialsignup: "/free-trial",
  orderConformationReceipt: "/order-Receipt/:id",
  acceptInvitation: "/accept-invitation",
  ShippingConfirmation: "/shipping-confirmation",
  OldShippingConfirmation: "/ShippingConfirmation", // Just for backup for old email
  invoice: "/invoice/:id",
  CurriculumSubsctiption: "/curriculum-subscriptions",
};
